import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { OrdenTrabajo } from "../interfaces";
import { cellNotFilter, formatDate } from "../utils";
import { IconButton, Tooltip } from "@mui/material";
import ImageIcon from '@mui/icons-material/Image';

export const useTableColumnsOrdenTrabajo = () => {


  const columnsRechazoTecnicoOT = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(() => [
    {
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        row.original?.prospecto_data?.razon_social||""
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => (
        row.original?.prospecto_data?.identificacion || ""
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      size: 100,
      Cell: ({ row }) => (
        row.original?.prospecto_data?.tipo_identificacion || ""
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'observacion_rechazo_tecnico',
      header: 'Observación Rechazo Técnico',
      size: 600,
      Cell: ({ row }) => (
        row.original?.observaciones?.observacion_rechazo_tecnico || "N/A"
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'urls_fotos_rechazo_tecnico',
      header: 'Evidencias',
      size: 200,
      Cell: ({ row }) => (

        row.original?.urls_fotos_rechazo_tecnico && row.original?.urls_fotos_rechazo_tecnico?.length>0?
        <>
          {
            row.original?.urls_fotos_rechazo_tecnico?.[0]?.photoUrl?
            <Tooltip title="Evidencia 1">
              <IconButton onClick={() => window.open((row.original?.urls_fotos_rechazo_tecnico?.[0]?.photoUrl || ""), '_blank' ) }>
                <ImageIcon color="primary" />
              </IconButton>
            </Tooltip>
            :null
          }
          {
            row.original?.urls_fotos_rechazo_tecnico?.[1]?.photoUrl?
            <Tooltip title="Evidencia 2">
              <IconButton onClick={() => window.open((row.original?.urls_fotos_rechazo_tecnico?.[1]?.photoUrl+"?"+new Date().getTime() || ""), '_blank' ) }>
                <ImageIcon color="secondary" />
              </IconButton>
            </Tooltip>
            :null
          }
        </>
        : "N/A"
      )
    },
    {
      accessorKey: 'flota_nombre',
      header: 'flota',
      size: 200,
      Cell: ({ row }) => (
        row.original?.flota_data?.nombre
      )
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero_referencia',
      size: 200,
    },

    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
    },
    // {
    //   ...cellNotFilter,
    //   accessorKey: 'fecha_creacion',
    //   header: 'fecha preventa',
    //   size: 200,
    //   Cell: ({ row }) => (
    //     formatDateWithTimeAMPM(row.original.fecha_creacion!)
    //   ),
    // },
    {
      accessorKey: 'fecha_instalacion',
      header: 'Fecha Instalacion',
      enableColumnFilter: false,
      size: 200,
      Cell: ({ row }) =>
        formatDate(row.original?.fecha_instalacion) || 'N/A',
    },
    {
      accessorKey: 'hora_instalacion',
      header: 'Hora de Instación',
      size: 200,
      Cell: ({ row }) =>
      (row.original?.hora_instalacion || "")
    },
    {
      accessorKey: 'ciudad_nombre',
      header: 'Ciudad',
      size: 200,
      Cell: ({ row }) =>
        row.original?.ciudad_data?.nombre || 'N/A',
      // row.original?.cliente_data?.provincia_data?.nombre || 'N/A',
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },

  ], []);








  return {
    columnsRechazoTecnicoOT
  }
}